import React from 'react';
import { SkeletonRegistryItem } from '../../../../registry/skeleton/SkeletonRegistryItem';
import { SkeletonRegistryCategory } from '../../../../registry/skeleton/SkeletonRegistryCategory';
import { DraftQuestionAd } from '../../../Defer/components/ads/DraftQuestionAd';
import { SkeletonRegistryDraftQuestionPart } from './questionpart/SkeletonRegistryDraftQuestionPart';
export class SkeletonRegistryDraftQuestion extends SkeletonRegistryCategory {
    label = 'Question';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_q = new SkeletonRegistryDraftQuestionPart(this);
    DraftRun_DraftQuestionAd = () => new SkeletonRegistryItem({
        label: 'Draft Question ad',
        jsx: ({ question }) => question && React.createElement(DraftQuestionAd, { key: question.id, question: question }),
    });
}
